import { render, staticRenderFns } from "./OurPrinciples.vue?vue&type=template&id=10883982&scoped=true&"
import script from "./OurPrinciples.vue?vue&type=script&lang=js&"
export * from "./OurPrinciples.vue?vue&type=script&lang=js&"
import style0 from "./OurPrinciples.vue?vue&type=style&index=0&id=10883982&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10883982",
  null
  
)

export default component.exports